import React from "react";
import PropTypes from "prop-types";
import { Button } from 'components/common';

/**
 * What the Payment Accountant does while the payment is Processing:
 *   Non-HSBC — record the payment made outside the Portal (opens Mark as paid);
 *   HSBC     — open ERP & bank, where the instruction is sent to HSBC.
 * Shown on the page banner and on the Processing step of the approval progress.
 */
const DisbursementAction = ({ canMarkPaid = false, hsbc = false, onMarkPaid, onOpenBank, className = "tw-mt-2" }) => {
  if (canMarkPaid && onMarkPaid) {
    return <Button size="sm" variant="success" className={className} onClick={onMarkPaid}>Mark as paid</Button>;
  }
  if (hsbc && onOpenBank) {
    return (
      <Button size="sm" variant="secondary" className={className} onClick={onOpenBank}>
        Send instruction to HSBC →
      </Button>
    );
  }
  return null;
};

DisbursementAction.propTypes = {
  canMarkPaid: PropTypes.bool,
  hsbc: PropTypes.bool,
  onMarkPaid: PropTypes.func,
  onOpenBank: PropTypes.func,
  className: PropTypes.string,
};

export default DisbursementAction;
